import { render, staticRenderFns } from "./Imoveis.vue?vue&type=template&id=906cfade&scoped=true&"
import script from "./imoveis.js?vue&type=script&lang=js&"
export * from "./imoveis.js?vue&type=script&lang=js&"
import style0 from "./Imoveis.vue?vue&type=style&index=0&id=906cfade&scoped=true&lang=css&"
import style1 from "./Imoveis.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906cfade",
  null
  
)

component.options.__file = "Imoveis.vue"
export default component.exports